import { render, staticRenderFns } from "./ExceptionWeekdays.vue?vue&type=template&id=23f4c060"
import script from "./ExceptionWeekdays.vue?vue&type=script&lang=js"
export * from "./ExceptionWeekdays.vue?vue&type=script&lang=js"
import style0 from "./ExceptionWeekdays.vue?vue&type=style&index=0&id=23f4c060&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports